(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["mx-ctmods-home"] && !Shopify.designMode) return;
  try {
    
  const initMxJourneyLife = () => {
    document.querySelectorAll('.mx-ct__stories').forEach((track) => {
      if (track.dataset.mxLifeReady === 'true') return;
      const slides = Array.from(track.querySelectorAll('.mx-ct__story'));
      if (!slides.length) return;
      track.dataset.mxLifeReady = 'true';
      const setActive = (activeSlide) => {
        slides.forEach((slide) => slide.classList.toggle('is-active', slide === activeSlide));
      };
      setActive(slides[0]);
      slides.forEach((slide) => {
        slide.addEventListener('mouseenter', () => {
          if (window.innerWidth > 989) setActive(slide);
        });
        slide.addEventListener('focus', () => {
          if (window.innerWidth > 989) setActive(slide);
        });
        slide.addEventListener('click', (event) => {
          if (window.innerWidth > 989 && !slide.classList.contains('is-active')) {
            event.preventDefault();
            setActive(slide);
          }
        });
      });
    });
  };
  initMxJourneyLife();
  document.addEventListener('shopify:section:load', initMxJourneyLife);

  const initMxBrandStories = () => {
    document.querySelectorAll('[data-mx-brand-story]').forEach((story) => {
      if (story.dataset.ready === 'true') return;
      const steps = Array.from(story.querySelectorAll('[data-story-step]'));
      const panels = Array.from(story.querySelectorAll('[data-story-panel]'));
      const images = Array.from(story.querySelectorAll('[data-story-image]'));
      if (!steps.length) return;
      story.dataset.ready = 'true';
      let active = 0;
      const show = (index) => {
        active = (index + steps.length) % steps.length;
        steps.forEach((step, i) => {
          step.classList.toggle('is-active', i === active);
          step.setAttribute('aria-selected', i === active ? 'true' : 'false');
        });
        panels.forEach((panel, i) => panel.classList.toggle('is-active', i === active));
        images.forEach((image, i) => image.classList.toggle('is-active', i === active));
      };
      steps.forEach((step, index) => step.addEventListener('click', () => show(index)));
      story.querySelector('[data-story-prev]')?.addEventListener('click', () => show(active - 1));
      story.querySelector('[data-story-next]')?.addEventListener('click', () => show(active + 1));
    });
  };
  initMxBrandStories();
  document.addEventListener('shopify:section:load', initMxBrandStories);

  } catch(e) { console.error(e); }
})();
})();
